import React from 'react';
import { Link } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { Row, Col, Icon } from 'antd';
import Text from 'antd/lib/typography/Text';
import * as PropTypes from 'prop-types';
import routeLocations from '../../../../utility/route-locations';
import { isPurCoInstall } from "../../../../configWeb";


const button1ThemeColour = 'rgb(68,135,96)';
const button2ThemeColour = '#408CCB'; // same as primary component
const button3ThemeColour = 'rgb(44,139,145)';
const button4ThemeColour = 'rgb(103,106,108)';

function DashboardButtonLink({
  iconType, title, description, to, themeColour,
}) {
    const colSpan1 = isPurCoInstall() ? 6 : 8;
    const colSpan2 = isPurCoInstall() ? 18 : 16;
  return (
    <Link to={to}>
      <div className="via-button-dashboard">
        <Row align="middle" type="flex">
          <Col span={colSpan1}>
            <div className="via-button-dashboard-circle-icon" style={{ backgroundColor: themeColour || '' }}>
              <div className="via-button-dashboard-circle-sizing">
                <Icon className="via-button-dashboard-icon" type={iconType} />
              </div>
            </div>
          </Col>
          <Col span={colSpan2}>
            <Row align="middle" justify="start" type="flex">
              <Text className="via-button-dashboard-header" style={{ color: themeColour || '' }}>{title}</Text>
            </Row>
            <Row align="middle" justify="start" type="flex">
              <Text className="via-button-dashboard-text">{description}</Text>
            </Row>
          </Col>
        </Row>
      </div>
    </Link>
  );
}

// Validate the prop type parameters.
DashboardButtonLink.propTypes = {
  description: PropTypes.string.isRequired,
  iconType: PropTypes.string.isRequired,
  themeColour: PropTypes.string,
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
};

DashboardButtonLink.defaultProps = {
  themeColour: null,
};

function DashboardButtons({ intl, isLoading }) {
    const colSpace = isPurCoInstall() ? 8 : 6;
  return (
    <div className="dashboard-shortcut-list">
      <Col xs={24} sm={12} md={12} lg={colSpace} xl={colSpace} style={isPurCoInstall() ? {display: "none"} : {}}>
        <DashboardButtonLink
          to={routeLocations.purchaseCredits}
          iconType="shopping-cart"
          title={intl.formatMessage({ id: 'purchaseInspections' })}
          description={intl.formatMessage({ id: 'paymentButtonSummary' })}
          themeColour={button1ThemeColour}
          isLoading={isLoading}
          style={isPurCoInstall() ? {display: "none"} : {}}
        />
      </Col>
      <Col xs={24} sm={12} md={12} lg={colSpace} xl={colSpace}>
        <DashboardButtonLink
          to={routeLocations.inspectionList}
          iconType="file-done"
          title={intl.formatMessage({ id: 'viewInspections' })}
          description={intl.formatMessage({ id: 'dashboardInspectText' })}
          themeColour={button2ThemeColour}
          isLoading={isLoading}
        />
      </Col>
      <Col xs={24} sm={12} md={12} lg={colSpace} xl={colSpace}>
        <DashboardButtonLink
          to={routeLocations.configure_vehicle}
          iconType="car"
          title={intl.formatMessage({ id: 'dashboardVehicleTitle' })}
          description={intl.formatMessage({ id: 'dashboardVehicleText' })}
          themeColour={button3ThemeColour}
          isLoading={isLoading}
        />
      </Col>
      <Col xs={24} sm={12} md={12} lg={colSpace} xl={colSpace}>
        <DashboardButtonLink
          to={routeLocations.configure}
          iconType="setting"
          title={intl.formatMessage({ id: 'configure' })}
          description={intl.formatMessage({ id: 'dashboardConfigText' })}
          themeColour={button4ThemeColour}
          isLoading={isLoading}
        />
      </Col>
    </div>
  );
}

// Validate the prop type parameters.
DashboardButtons.propTypes = {
  intl: PropTypes.oneOfType([PropTypes.any]).isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default injectIntl(DashboardButtons);
